import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Space, Card, Select, Row, Col, Flex } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/ImagePicker"
import ThemeSetting from "components/pickers/theme-setting"
import { CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import ProductsPicker from './ProductsPicker';
import _ from "lodash"




const ProductBlock = ({ data, onChange, onDelete, form }) => {
    const display = Form.useWatch('display', form);





    return (
        <>
            <Form.Item
                label="Kiểu"
                name="display"
                rules={[{ required: true, message: 'Please input your website!' }]}

            >
                <Select options={[{ label: "Slide", value: "carousel" }, { label: "Slide nhỏ", value: "carousel_small" }, { label: "Danh sách", value: "list" }]} style={{ width: "100%" }} > </Select>
            </Form.Item>

            <Form.Item
                label="Tự động chạy"
                name={['slide_config', 'autoplay']}
                valuePropName='checked'
                hidden={!["carousel", "carousel_small"].includes(display)}
                layout='horizontal'

            >
                <Checkbox ></Checkbox>
            </Form.Item>



            <Form.Item
                label="Sản phẩm"
                name="products"

            >
                <ProductsPicker></ProductsPicker>
            </Form.Item>
     
        </>

    )
}
export default ProductBlock;